<template>
  <div>
  <Navbar></Navbar>
  <MainHeader></MainHeader>
  <main>
    <Sobre></Sobre>
    <Principios></Principios>
    <CursosServicos></CursosServicos>
    <Depoimentos></Depoimentos>
  </main>
  <RedesSociais></RedesSociais>
  <Footer></Footer>
  </div>
</template>

<style scoped lang="scss">
section {
  display: flex;
  flex-direction: column;
  align-items: center;

  h2 {
    width: 900px;
    max-width: 100%;
  }

  p {
    font-size: 18px;
    max-width: 900px;
    margin-top: 0;
  }

}

.placeholder {
  height: 300px;
}
</style>

<script>
// @ is an alias to /src
import Navbar from '@/components/Navbar.vue'
import MainHeader from '@/components/home/MainHeader.vue'
import Sobre from '@/components/home/Sobre.vue'
import Principios from '@/components/home/Principios.vue'
import CursosServicos from '@/components/home/CursosServicos.vue'
import Depoimentos from '@/components/home/Depoimentos.vue'
import RedesSociais from '@/components/RedesSociais.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'home',
  components: {
    Navbar,
    MainHeader,
    Sobre,
    Principios,
    CursosServicos,
    Depoimentos,
    RedesSociais,
    Footer,
  }
}
</script>
